import {parseNumber} from '@benchling/js-utils';

import {assert} from 'Asserts';
import {NumericString} from 'notebook/integrations/registry/MixtureGroupConstants';

/*
 * Return the number of digits in a number represented as a string, with the following rules:
 *    - include trailing decimal zeros.
 *    - exclude leading zeros.
 *
 * This function represents specific rules for precision that we've defined for mixture amounts, and is needed
 * by the client-side math for ingredient target amount because the decimal.js library does not retain
 * trailing decimal zeros, so using Decimal.precision() does not work for our needs when considering the
 * precision of a user-entered amount.
 *
 * Note: Non-decimal numeric strings are not supported.
 */
export default function numDigitsForMixtureAmount(numericString: NumericString): number {
  let numberAsString = numericString.stringValue.trim();
  assert(parseNumber(numberAsString) != null, 'Expected a string representing a valid number');

  const isScientificNotation = !/^[0-9.+-]+$/.test(numberAsString);
  if (isScientificNotation) {
    // If it's in scientific notation, only count the portion before the exponent
    const indexOfE = numberAsString.toLowerCase().indexOf('e');
    assert(
      indexOfE !== -1,
      `Expected number detected as scientific notation to contain e or E, but was ${numberAsString}`
    );
    numberAsString = numberAsString.substring(0, indexOfE);
  }

  numberAsString = numberAsString.replace(/[.+-]/g, '');
  numberAsString = numberAsString.replace(/^0+/, '');
  return numberAsString.length;
}
